import {
  ISSUE_COLORS,
  type CaseIssue,
  type DocReviewState,
} from '../components/review/types'
import { type Comment } from './mockDocuments'

// ── Initial document review states ────────────────────────────────────
export const INITIAL_DOC_STATES: Record<string, DocReviewState> = {
  'ACME-00004': {
    reviewed: true,
    reviewedBy: 'Sarah Chen',
    reviewedAt: '2023-10-20 09:30',
    classification: 'hot',
    classifiedBy: 'Sarah Chen',
    privileged: false,
  },
  'ACME-00005': {
    reviewed: true,
    reviewedBy: 'Michael Torres',
    reviewedAt: '2023-10-21 14:15',
    classification: null,
    privileged: false,
  },
  'ACME-00010': {
    reviewed: true,
    reviewedBy: 'Sarah Chen',
    reviewedAt: '2023-10-22 11:00',
    classification: 'critical',
    classifiedBy: 'Sarah Chen',
    privileged: false,
  },
  'ACME-00012': {
    reviewed: false,
    classification: null,
    privileged: true,
    privilegedBy: 'Partner J. Davis',
    privilegedAt: '2023-10-19 16:00',
  },
  'ACME-00022': {
    reviewed: true,
    reviewedBy: 'Michael Torres',
    reviewedAt: '2023-10-25 13:45',
    classification: 'hot',
    classifiedBy: 'Michael Torres',
    privileged: true,
    privilegedBy: 'Partner J. Davis',
    privilegedAt: '2023-10-24 10:00',
  },
  'ACME-00030': {
    reviewed: true,
    reviewedBy: 'Sarah Chen',
    reviewedAt: '2023-10-26 08:45',
    classification: 'tbd',
    classifiedBy: 'Sarah Chen',
    privileged: true,
    privilegedBy: 'Partner J. Davis',
    privilegedAt: '2023-10-26 09:00',
  },
}

// ── Case issues ───────────────────────────────────────────────────────
export const DEFAULT_CASE_ISSUES: CaseIssue[] = [
  { id: 'issue-1', label: 'Lease Agreement', color: ISSUE_COLORS[0] },
  { id: 'issue-2', label: 'Zoning / Land Use', color: ISSUE_COLORS[1] },
  { id: 'issue-3', label: 'Environmental', color: ISSUE_COLORS[2] },
  { id: 'issue-4', label: 'Title Defect', color: ISSUE_COLORS[3] },
  { id: 'issue-5', label: 'Financial Damages', color: ISSUE_COLORS[4] },
]

// ── Initial doc → issue mappings ──────────────────────────────────────
export const INITIAL_DOC_ISSUES: Record<string, string[]> = {
  'ACME-00004': ['issue-1', 'issue-5'],
  'ACME-00010': ['issue-3'],
  'ACME-00022': ['issue-2', 'issue-4'],
}
